// @ts-check

import ResetGridLink from '~/components/Shared/DataGrid/ResetGridLink';
import { useScheduleDataGridContext } from '~/components/Forms/ScheduleDataGrid/ScheduleDataGrid.context';
import { DEFAULT_SORT_MODEL, EventNames } from '~/components/Forms/ScheduleDataGrid/ScheduleDataGrid.utils';

export default function ResetScheduleGridLink() {
    const { settings } = useScheduleDataGridContext();

    return (
        <ResetGridLink
            settings={settings}
            resetTableEventName={EventNames.RESET_TABLE}
            defaultSortModel={DEFAULT_SORT_MODEL}            
        />
    );
} 